import { createContext } from "react";

interface ThemeContextType {
  darkMode: boolean;
  toggleDarkMode: () => void;
}

export const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

interface DemoContextType {
  isDemoMode: boolean;
  demoClient?: string;
  setDemoClient: (name: string) => void;
}

export const DemoContext = createContext<DemoContextType | undefined>(undefined);
